module.exports = __webpack_public_path__ + "static/media/gingerbread-man.60541570.svg";